var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5312 2.0625L11.9375 0.46875C11.6875 0.21875 11.2188 0 10.875 0H5.5C4.65625 0 4 0.6875 4 1.5V3H1.5C0.65625 3 0 3.6875 0 4.5V14.5C0 15.3438 0.65625 16 1.5 16H8.5C9.3125 16 10 15.3438 10 14.5V13H12.5C13.3125 13 14 12.3438 14 11.5V3.125C14 2.78125 13.7812 2.3125 13.5312 2.0625ZM8.3125 14.5H1.6875C1.5625 14.5 1.5 14.4375 1.5 14.3125V4.6875C1.5 4.59375 1.5625 4.5 1.6875 4.5H4V11.5C4 12.3438 4.65625 13 5.5 13H8.5V14.3125C8.5 14.4375 8.40625 14.5 8.3125 14.5ZM12.3125 11.5H5.6875C5.5625 11.5 5.5 11.4375 5.5 11.3125V1.6875C5.5 1.59375 5.5625 1.5 5.6875 1.5H9V4.25C9 4.6875 9.3125 5 9.75 5H12.5V11.3125C12.5 11.4375 12.4062 11.5 12.3125 11.5ZM12.5 3.5H10.5V1.5H10.7812C10.8438 1.5 10.875 1.53125 10.9062 1.5625L12.4375 3.09375C12.4688 3.125 12.5 3.15625 12.5 3.21875V3.5Z",
    fill: "#2A2A2A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.44498a07.svg";
export { ForwardRef as ReactComponent };